export const BOARD_KEYS = {
  all: ['boards'] as const,
  byProject: (orgId: string, projectId: string) => ['boards', orgId, projectId] as const,
  detail: (orgId: string, boardId: string) => ['boards', orgId, 'detail', boardId] as const,
  statuses: (orgId: string, boardId: string) => ['boards', orgId, 'statuses', boardId] as const,
  groups: (orgId: string, boardId: string) => ['boards', orgId, 'groups', boardId] as const,
  group: (orgId: string, boardId: string, groupId: string) =>
    ['boards', orgId, 'groups', boardId, groupId] as const,
  views: (orgId: string, boardId: string) => ['boards', orgId, 'views', boardId] as const,
};
